import React from 'react';

/**
 * برچسب تب یادداشت‌ها با نشانگر تعداد — بدون نیاز به ورود به تب
 */
const TabNotesLabel = ({ count = 0, icon, fullLabel = 'یادداشت‌ها', shortLabel = 'یادداشت' }) => (
  <span
    className="inline-flex items-center gap-1.5 pe-0.5"
    style={{ fontFamily: 'CustomFont', fontSize: 'clamp(11px, 2vw, 13px)' }}
  >
    {icon}
    <span className="hidden sm:inline">{fullLabel}</span>
    <span className="sm:hidden">{shortLabel}</span>
    {count > 0 && (
      <span
        className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold leading-none shadow-sm"
        style={{ backgroundColor: '#f59e0b', color: '#fff', fontFamily: 'CustomFont' }}
        title={`${count} یادداشت`}
        aria-label={`${count} یادداشت`}
      >
        {count > 99 ? '99+' : count}
      </span>
    )}
  </span>
);

export default TabNotesLabel;
